import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'
import StatisticsCards from '@/views/dashboard/_components/statistics-cards/statistics-cards.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'statistics-cards',
  props: {
    todayOutboundCount: { default: 14 },
    pendingApprovalCount: { default: 5 },
    blockedCount: { default: 50 }
  },
  setup(__props: any) {

const { t } = useI18n()
const props = __props

const statisticsItems = computed(() => {
  const spanPair = IS_JP_ONLY_BUILD ? 12 : 8
  const items = [
    { label: t('sensitiveFileScanning.todayOutboundCount'), value: props.todayOutboundCount, span: spanPair },
    { label: t('sensitiveFileScanning.todayBlockedCount'), value: props.blockedCount, span: spanPair },
  ]
  if (!IS_JP_ONLY_BUILD) {
    items.push({ label: t('sensitiveFileScanning.pendingApproval'), value: props.pendingApprovalCount, span: 8 })
  }
  return items
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(StatisticsCards, { items: statisticsItems.value }, null, 8, ["items"]))
}
}

})